module.exports = __webpack_public_path__ + "img/types.40aa61cc.svg";